import { render, staticRenderFns } from "./CustomerMailEvents.vue?vue&type=template&id=340f66f1&"
import script from "./CustomerMailEvents.vue?vue&type=script&lang=js&"
export * from "./CustomerMailEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports